/**
 * Date-range rules for the Field details water-potential graph
 * (FieldDetailsWPGraph, used by the Farm View tab and the Field View).
 *
 * Archive fields default to the full history ("Max", MAX_DAYS_BACK). Leaving
 * archive mode must not carry that range over: the next active field would
 * otherwise inherit 8750 days (a selected "Max" pill in the Graphs layout, no
 * selected chip in the Field View) and load ~24 years of samples.
 */

const DEFAULT_DAYS_BACK = 14;
// Archive fields default to the full history ("Max"). 8750 days (~24y); using
// 8750 (10-digit timestamp) avoids the DynamoDB string-comparison bug larger
// values triggered — same value/rationale as WaterPotentialGraphContainer.
const MAX_DAYS_BACK = 8750;

// labelKey: short chip label. rangeLabelKey: long label for the narrow-width
// dropdown (same keys the Soil temperature graph's range dropdown uses).
const DAYS_BACK_OPTIONS = [
  { days: 1, labelKey: 'date_chip_1d', rangeLabelKey: 'last_day' },
  { days: 7, labelKey: 'date_chip_1w', rangeLabelKey: 'last_week' },
  { days: 14, labelKey: 'date_chip_2w', rangeLabelKey: 'last_two_weeks' },
  { days: 30, labelKey: 'date_chip_1m', rangeLabelKey: 'last_month' },
  { days: 180, labelKey: 'date_chip_6m', rangeLabelKey: 'last_six_months' },
  { days: 365, labelKey: 'date_chip_1y', rangeLabelKey: 'last_year' },
];

// "Max" chip — only offered in the Field details "Graphs" layout (Farm View
// tab). The Field View (non-graphs layout) keeps the six options above.
const GRAPHS_LAYOUT_OPTIONS = [
  ...DAYS_BACK_OPTIONS,
  { days: MAX_DAYS_BACK, labelKey: 'max', rangeLabelKey: 'max' },
];

const rangeOptionsFor = (graphsLayout) =>
  graphsLayout ? GRAPHS_LAYOUT_OPTIONS : DAYS_BACK_OPTIONS;

// Range to use after the field or the archive/active mode changed:
// archive → Max; archive → active resets to the default; active → active
// keeps the user's current range.
const nextDaysBack = ({ prevFieldState, fieldState, currentDaysBack }) => {
  if (fieldState === 'archive') return MAX_DAYS_BACK;
  if (prevFieldState === 'archive') return DEFAULT_DAYS_BACK;
  return currentDaysBack ?? DEFAULT_DAYS_BACK;
};

module.exports = {
  DEFAULT_DAYS_BACK,
  MAX_DAYS_BACK,
  DAYS_BACK_OPTIONS,
  GRAPHS_LAYOUT_OPTIONS,
  rangeOptionsFor,
  nextDaysBack,
};
